import {
    Checkbox,
    FormControlLabel,
  } from "@mui/material";
import classes from '../CustomInputs.module.css';
import { useState } from "react";

const CheckboxInput = (props) => {
  const [checked, setChecked] = useState(props?.checked);

  return (
    <div className={classes.appInput}>
        <FormControlLabel
            control={
              <Checkbox
                id={props?.id}
                checked={checked}
                onChange={(event, newValue) => {
                    setChecked(newValue);
                    props.onChange({ [props?.id]: newValue});
                }}
                name={props?.name} 
                classes={{ checked: classes.switchChecked }}
              />
            }
            label={
              <div className={classes.checkboxLabel}>
                {props?.label}
              </div>
            }
          />
    </div>
  )
}

export default CheckboxInput;